import { toast } from "react-toastify";
import { backend } from "../../api";
import {
  FETCH_MEMBER_ADCARDS_FAIL,
  FETCH_MEMBER_ADCARDS_REQUEST,
  FETCH_MEMBER_ADCARDS_SUCCESS,
  PROMOTED_BY,
} from "../constants";

export const getMemberAdcards = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_MEMBER_ADCARDS_REQUEST });
    const { data } = await backend.get(`/adcard?member_id=${id}`);

    dispatch({ type: FETCH_MEMBER_ADCARDS_SUCCESS, payload: data.data });
  } catch (error) {
    toast.error(error.response ? error.response.data.message : error.message);

    dispatch({
      type: FETCH_MEMBER_ADCARDS_FAIL,
      payload: error.response ? error.response.data.message : error.message,
    });
  }
};

// when customer come through member's link member gets a discount
export const promotedBy = (member) => async (dispatch) => {
  dispatch({ type: PROMOTED_BY, payload: member });
};

// export const createAdCard = (adcard) => async (dispatch) => {
//   try {
//     dispatch({ type: CREATE_ADCARD_REQUEST });
//     const { data } = await backend.post("/adcard", adcard);
//     Swal.fire({
//       title: "Congratulations",
//       icon: "success",
//       confirmButtonText: "OK",
//       text: "Order Placed Successfully",
//     });
//     dispatch({ type: CREATE_ADCARD_SUCCESS, payload: data.data });
//   } catch (error) {
//     let message = error.response ? error.response.data.message : error.message;
//     toast.error(message);
//     dispatch({
//       type: CREATE_ADCARD_FAIL,
//       payload: message,
//     });
//   }
// };
